export const DAY_MONTH_YEAR_FORMAT = 'DD/MM/YYYY';
export const HOUR_MIN_FORMAT = 'h:mm A';
export const HOUR_MIN_SEC_DATE_FORMAT = 'HH:mm:ss DD/MM/YYYY';
export const MONTH_DAY_YEAR_FORMAT = 'MMM D, YYYY';
export const MDE_TIME_FORMAT = 'DD/MM/YYYY h:mm:ss A';
export const MONTH_DAY_YEAR_HOUSE_MIN_FORMAT = 'DD/MM/YYYY h:mm A';
